module.exports = __webpack_public_path__ + "img/gbta.2de7be47.jpg";